/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Report_HeadingInputs */

const ja_playdata_report_heading = /** @type {(inputs: Playdata_Report_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2025年版 日本eスポーツレポートを無料で入手`)
};

const en_playdata_report_heading = /** @type {(inputs: Playdata_Report_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Your FREE 2025 Japan Esports Report`)
};

/**
* | output |
* | --- |
* | "Get Your FREE 2025 Japan Esports Report" |
*
* @param {Playdata_Report_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_report_heading = /** @type {((inputs?: Playdata_Report_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Report_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_report_heading(inputs)
	return en_playdata_report_heading(inputs)
});